import { EvincedTypeNames, EvincedTypeNamesFromA11ygator } from '../consts/EvincedTypeNames';

export const isValidationOfEvincedType = (validationType: string): boolean => {
	return !!Object.values(EvincedTypeNames)
		.concat(Object.values(EvincedTypeNamesFromA11ygator))
		.find((v) => v === validationType);
};
